import { useEffect, useContext, createContext, useState } from "react";

interface IProd {
  id?: number;
  chave: number;
  descricao: string;
  preco_venda: number;
  grupo1: string;
  grupo2: string;
  grupo3: string;
  quantidade: number;
  observacao: string;
  tipo: string;
  kits?: any[];
  extras: IExtraProd[];
  picture: string;
  observacao_produto?: string;
}

interface IExtraProd {
  chave: number;
  descricao: string;
  qme: number;
  quantidade: number;
  ordem: number;
  preco_venda: number;
  chave_kit: number;
}

interface IUser {
  chave: number;
  nome: string;
  cpf: string;
}

interface IState {
  user: IUser;
  carrinho: IProd[];
}

const initialState: IState = {
  user: {
    chave: 0,
    nome: "",
    cpf: "",
  },
  carrinho: [],
};

export type IGestorContextType = {
  state: IState;
  addProd: (prod: IProd) => void;
  attProd: (prod: IProd) => void;
  removeProd: (id: number | undefined) => void;
  Login: (user: IUser) => void;
  Logout: () => void;
  CleanCart: () => void;
};

export const GestorContext = createContext<IGestorContextType | null>(null);

export default function GestorProvider({ children }: any) {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    const LocalState = localStorage.getItem("GESTORSTATE");
    if (LocalState) {
      setState(JSON.parse(LocalState));
    }
  }, []);

  useEffect(() => {
    if (state !== initialState) {
      localStorage.setItem("GESTORSTATE", JSON.stringify(state));
    }
  }, [state]);

  const addProd = (prod: IProd) => {
    const newState = state;
    const findProd = state.carrinho.findIndex((e) => e.id == prod.id);
    if (findProd >= 0) {
      const oldCarrinho = newState.carrinho;
      oldCarrinho[findProd] = {
        ...oldCarrinho[findProd],
        quantidade: oldCarrinho[findProd].quantidade + prod.quantidade,
      };
      newState.carrinho = oldCarrinho;
      setState({ ...newState });
      return;
    }
    newState.carrinho.push(prod);
    setState({ ...newState });
  };

  const attProd = (prod: IProd) => {
    const newState = state;
    const findProd = state.carrinho.findIndex((e) => e.id == prod.id);
    if (findProd >= 0) {
      const oldCarrinho = newState.carrinho;
      oldCarrinho[findProd] = {
        ...prod,
      };
      newState.carrinho = oldCarrinho;
      setState({ ...newState });
      return;
    } else {
      newState.carrinho.push(prod);
      setState({ ...newState });
      return;
    }
  };

  const removeProd = (id: number | undefined) => {
    if(!id) {
      return;
    }
    const oldState = state;
    const newCart = oldState.carrinho.filter((e) => e.id != id);
    const newState: IState = {
      user: oldState.user,
      carrinho: newCart,
    };
    setState({ ...newState });
  };

  const Login = (user: IUser) => {
    const oldState = state;
    const newState: IState = {
      user: { ...user },
      carrinho: oldState.carrinho,
    };
    setState({ ...newState });
  };

  const Logout = () => {
    const oldState = state;
    const newState: IState = {
      user: { ...initialState.user },
      carrinho: oldState.carrinho,
    };
    setState({ ...newState });
  };

  const CleanCart = () => {
    const oldState = state;
    const newState: IState = {
      user: oldState.user,
      carrinho: [],
    };
    setState({ ...newState });
  };

  return (
    <GestorContext.Provider
      value={{
        state,
        addProd,
        removeProd,
        Login,
        Logout,
        attProd,
        CleanCart,
      }}
    >
      {children}
    </GestorContext.Provider>
  );
}
